import { render, staticRenderFns } from "./BpRadio.vue?vue&type=template&id=63591bd8&scoped=true&"
import script from "./BpRadio.vue?vue&type=script&lang=js&"
export * from "./BpRadio.vue?vue&type=script&lang=js&"
import style0 from "./BpRadio.vue?vue&type=style&index=0&id=63591bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63591bd8",
  null
  
)

export default component.exports